import { useEffect } from 'react';

declare global {
  interface Window {
    widget: {
      setOptions: (options: { feedUrl: string }) => void;
      render: () => void;
    };
  }
}

export default function ContactForm() {
  useEffect(() => {
    const scriptId = 'softcredito';

    const initWidget = () => {
      window.widget.setOptions({
        feedUrl: 'https://softcredito.com/produccion/CRECEPRESTACIONES/app/widget',
      });
      window.widget.render();
    };

    if (document.getElementById(scriptId)) {
      if (window.widget) initWidget();
      return;
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://softcredito.com/produccion/CRECEPRESTACIONES/app/js/widget/embed.js';
    script.type = 'text/javascript';
    script.onload = initWidget;
    document.body.appendChild(script);
  }, []);

  return (
    <section id="contacto" className="relative py-18 md:py-24 overflow-hidden" style={{ background: 'oklch(var(--background-50))' }}>
      <div id="softcredito-widget"></div>
    </section>
  );
}